import Payment from '@/models/Payment'
import Api from '@/api'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
  },

  mutations: {
    setPaymentList(state, payments) {
      each(payments, (payment) => {
        const exist = find(state.list, { id: payment.id })
        if (!exist) {
          state.list.push(new Payment(payment))
        }
      })
    },

    clearPaymentListItemDetails(state, id) {
      const index = findIndex(state.list, { id: id })
      state.list.splice(index, 1)
    },

    setPaymentListItemDefault(state, id) {
      const current = findIndex(state.list, { is_default: true })

      if (current >= 0) {
        state.list[current].is_default = false
      }

      const index = findIndex(state.list, { id: id })
      state.list[index].is_default = true
    },
  },

  actions: {
    async getPayments({ commit }, params) {
      const { data } = await Api.get(`auth/payment-methods`)
      commit('setPaymentList', data.data)
    },

    async createPayment({ commit, state }, formData) {
      const { data } = await Api.post(`auth/payment-methods`, formData)
      state.list.unshift(new Payment(data.data))
    },

    async deletePayment({ commit, state }, id) {
      await Api.delete(`auth/payment-methods/${id}`)
      commit('clearPaymentListItemDetails', id)
    },

    async setCardAsPrimary({ commit, state }, id) {
      await Api.post(`auth/payment-methods/${id}/default`)
      commit('setPaymentListItemDefault', id)
    },
  },
}
